import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/router";
import * as i3 from "@fortawesome/angular-fontawesome";
import * as i4 from "@progress/kendo-angular-navigation";
function ContentHeaderComponent_h1_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1");
    i0.ɵɵelement(1, "i", 7);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function ContentHeaderComponent_ng_template_5_a_0_fa_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 12);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("icon", item_r2.icon);
  }
}
const _c0 = function (a0) {
  return [a0];
};
function ContentHeaderComponent_ng_template_5_a_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵtemplate(1, ContentHeaderComponent_ng_template_5_a_0_fa_icon_1_Template, 1, 1, "fa-icon", 11);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(5, _c0, item_r2.route));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r2.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(4, 3, item_r2.title), "");
  }
}
function ContentHeaderComponent_ng_template_5_span_1_fa_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 12);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("icon", item_r2.icon);
  }
}
function ContentHeaderComponent_ng_template_5_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtemplate(1, ContentHeaderComponent_ng_template_5_span_1_fa_icon_1_Template, 1, 1, "fa-icon", 11);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r2.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(4, 2, item_r2.title), "");
  }
}
function ContentHeaderComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ContentHeaderComponent_ng_template_5_a_0_Template, 5, 7, "a", 8);
    i0.ɵɵtemplate(1, ContentHeaderComponent_ng_template_5_span_1_Template, 5, 4, "span", 9);
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", item_r2.route);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r2.route);
  }
}
const _c1 = function (a0) {
  return {
    "header-padding": a0
  };
};
const _c2 = ["*"];
export class ContentHeaderComponent {
  constructor() {
    this.compacted = false;
  }
  onItemClick(event) {}
}
ContentHeaderComponent.ɵfac = function ContentHeaderComponent_Factory(t) {
  return new (t || ContentHeaderComponent)();
};
ContentHeaderComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: ContentHeaderComponent,
  selectors: [["app-content-header"]],
  inputs: {
    title: "title",
    breadcrumb: "breadcrumb",
    compacted: "compacted"
  },
  ngContentSelectors: _c2,
  decls: 8,
  vars: 5,
  consts: [[1, "row", "mb-3"], [1, "col"], [1, "content-header", 3, "ngClass"], [4, "ngIf"], [3, "items", "itemClick"], ["kendoBreadCrumbItemTemplate", ""], [1, "col-auto", "ml-auto", "content-header"], [2, "margin-left", "-10px", "font-size", "20px", "padding-right", "10px"], ["class", "k-cursor-pointer k-flex-none k-breadcrumb-link", 3, "routerLink", 4, "ngIf"], ["class", "k-cursor-pointer k-flex-none k-breadcrumb-link k-state-disabled", 4, "ngIf"], [1, "k-cursor-pointer", "k-flex-none", "k-breadcrumb-link", 3, "routerLink"], [3, "icon", 4, "ngIf"], [3, "icon"], [1, "k-cursor-pointer", "k-flex-none", "k-breadcrumb-link", "k-state-disabled"]],
  template: function ContentHeaderComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "section", 2);
      i0.ɵɵtemplate(3, ContentHeaderComponent_h1_3_Template, 4, 1, "h1", 3);
      i0.ɵɵelementStart(4, "kendo-breadcrumb", 4);
      i0.ɵɵlistener("itemClick", function ContentHeaderComponent_Template_kendo_breadcrumb_itemClick_4_listener($event) {
        return ctx.onItemClick($event);
      });
      i0.ɵɵtemplate(5, ContentHeaderComponent_ng_template_5_Template, 2, 2, "ng-template", 5);
      i0.ɵɵelementEnd()()();
      i0.ɵɵelementStart(6, "div", 6);
      i0.ɵɵprojection(7);
      i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1, !ctx.compacted));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.title);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("items", ctx.breadcrumb);
    }
  },
  dependencies: [i1.NgClass, i1.NgIf, i2.RouterLink, i3.FaIconComponent, i4.BreadCrumbComponent, i4.BreadCrumbItemTemplateDirective, i1.AsyncPipe],
  styles: ["@charset \"UTF-8\";\nfa-icon[_ngcontent-%COMP%] {\n  width: 20px;\n  text-align: center;\n  display: inline-block;\n}\n\n.k-breadcrumb[_ngcontent-%COMP%]   .k-breadcrumb-link[_ngcontent-%COMP%], .k-breadcrumb[_ngcontent-%COMP%]   .k-breadcrumb-link[_ngcontent-%COMP%] {\n  color: #333;\n}\n\n.k-breadcrumb[_ngcontent-%COMP%]   .k-breadcrumb-link[_ngcontent-%COMP%]:hover, .k-breadcrumb[_ngcontent-%COMP%]   .k-breadcrumb-link.k-state-hover[_ngcontent-%COMP%] {\n  color: #007bff;\n  background-color: inherit !important;\n}\n\n.content-header[_ngcontent-%COMP%] {\n  position: relative;\n}\n.content-header[_ngcontent-%COMP%]    > h1[_ngcontent-%COMP%] {\n  margin: 0;\n  font-size: 24px;\n}\n.content-header[_ngcontent-%COMP%]    > h1[_ngcontent-%COMP%]    > small[_ngcontent-%COMP%] {\n  font-size: 15px;\n  display: inline-block;\n  padding-left: 4px;\n  font-weight: 300;\n}\n.content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%] {\n  background: transparent;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 12px;\n  top: 15px;\n  right: 10px;\n  float: none;\n  padding: 5px 0px;\n  position: unset;\n}\n.content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%] {\n  color: #444;\n  text-decoration: none;\n  display: inline-block;\n}\n.content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]    > .fa[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]    > .glyphicon[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]    > .ion[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%]    > .fa[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%]    > .glyphicon[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%]    > .ion[_ngcontent-%COMP%] {\n  margin-right: 5px;\n}\n.content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    + li[_ngcontent-%COMP%]:before {\n  content: \">\u00A0\";\n}\n\n.header-padding[_ngcontent-%COMP%] {\n  padding-top: 10px;\n}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
  changeDetection: 0
});